import { withStyles } from '@material-ui/core/styles';
import { FieldLabel, Slider } from "@roc/ui";
import { observer } from "mobx-react";
import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';

const useSliderStyles = makeStyles(theme =>
  createStyles({
    slider: {
      marginTop: '2.5em',
      marginLeft: '2em',
      width: '85%',
    },
    helperText: {
      marginTop: theme.spacing(2),
    },
  })
);

const experienceMarks = [
  {
    value: 1,
    label: 'Newbie',
  },
  {
    value: 5,
    label: 'Seasoned investor',
  },
];

export const BorrowerExperienceRealStateMultifamily = observer(({ store, multiFamilyStore, ...rest }) => {
  const formFields = store.form.fields;
  const classes = useSliderStyles();

  return (
    <>
      <FieldLabel>
        How many 5+ unit multifamily projects have you completed?
      </FieldLabel>
      <TextField
        variant='outlined'
        type='number'
        value={formFields.multiFamilyExperience.value}
        onChange={(e) => {
            const value = parseInt(e.target.value, 10);
          store.onFieldChange('multiFamilyExperience', isNaN(value) ? 0 : value);
          }
        }
      />
    </>
  );
});